import { useTranslation } from "react-i18next";
import reval from "../../../assets/logo_rba.png";

export default function Historia() {
  const { t } = useTranslation();
  return (
    <section id="historia-section" className="section_inicial">
      <h1>{t("nos.historia.titulo")}</h1>
      <div className="flex">
        <p>
          {t("nos.historia.descricao.p1")}
          <br />
          {t("nos.historia.descricao.p2")}
          <br />
          {t("nos.historia.descricao.p3")}
          <br />
          {t("nos.historia.descricao.p4")}
        </p>
        <img src={reval} alt="Logo Reval Brasil" />
      </div>
    </section>
  );
}
